import { Box, CircularProgress, Grid } from "@mui/material";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

export function wrapper(content, deviceLayout, backgroundEnabled = false) {
    return (
        <SoftBox
            mt={deviceLayout == 'mobile' ? '4.25rem' : '5.5rem'}
            mx={deviceLayout == 'mobile' ? 1 : 2}
            width={`calc(100% - ${deviceLayout == 'mobile' ? '16px' : '32px'})`}
            borderRadius="20px"
            color={"white"}
            display="flex"
            position="absolute"
        >
            <Box width="100%" mb={deviceLayout == 'mobile' ? 1 : 2}>
                {backgroundEnabled ? (
                    <SoftBox borderRadius="20px" color={"white"} width="100%"
                        height={deviceLayout == 'mobile' ? '100%' : "calc(100svh - 5.5rem - 16px)"}
                        minHeight={deviceLayout == 'mobile' ? "calc(100svh - 4.25rem - 8px)" : "fit-content"}
                        sx={({ palette: { white }, functions: { rgba } }) => ({ backgroundColor: rgba(white.main, 0.7) })}
                    >
                        {content}
                    </SoftBox>
                ) : (
                    content
                )}

            </Box>
        </SoftBox>
    );
}

export function sidebarWrapper(content, controller, maxWidth = '100%', ignoreMiniNavbar = false) {
    const { miniNavbar, deviceLayout } = controller;

    return (
        <SoftBox
            mt={deviceLayout == 'mobile' ? '4.25rem' : '5.5rem'}
            mx={deviceLayout == 'mobile' ? 1 : 2}
            width={deviceLayout == 'mobile' ? `calc(100% - 16px)` : '20%'}
            minWidth="300px"
            maxWidth={maxWidth}
            color={"white"}
            display="flex"
            position="absolute"
        >
            <Box width="100%" mb={deviceLayout == 'mobile' ? 1 : 2}>
                {miniNavbar && !ignoreMiniNavbar ? (
                    <SoftBox borderRadius="16px" color={"white"} width="auto"
                        
                        height={"62px"}
                        minHeight={"62px"}
                        sx={({ palette: { white }, functions: { rgba } }) => ({ backgroundColor: rgba(white.main, 0.7) })}
                    >
                        {content}
                    </SoftBox>
                ) : (
                    <SoftBox borderRadius="16px" color={"white"} width="auto"
                        
                        height={deviceLayout == 'mobile' ? 'unset' : "calc(100svh - 5.5rem - 16px)"}
                        minHeight={deviceLayout == 'mobile' ? "calc(100svh - 4.25rem - 8px)" : "fit-content"}
                        sx={({ palette: { white }, functions: { rgba } }) => ({ backgroundColor: rgba(white.main, 0.7) })}
                    >
                        {content}
                    </SoftBox>
                )}

            </Box>
        </SoftBox >
    );
}

export function deviceViewWrapper(lhs, rhs, deviceLayout, has_liveview = false) {

    if (deviceLayout == 'mobile') {
        return (
            <Grid container spacing={1}>
                <Grid item xxs={12} x3l={6}>
                    {lhs}
                </Grid>
                <Grid item xxs={12} x3l={6}>
                    <Box pb={1}>
                        {rhs}
                    </Box>
                </Grid>
            </Grid>
        );
    }
    else {
        return (
            <Box display="flex" flex={1} flexDirection={{ xxs: "column", lg: "row" }} height={"calc(100svh - 10.25rem - 16px)"}>
                <Box flex={{ xxs: 12, lg: has_liveview ? 4 : 6 }} pb={{ xxs: 1, lg: 0 }} pr={{ xxs: 0, lg: 0.5 }}>
                    {lhs}
                </Box>
                <Box flex={{ xxs: 12, lg: has_liveview ? 8 : 6 }} pl={{ xxs: 0, lg: 0.5 }}>
                    {rhs}
                </Box>
            </Box>
        );
    }
}

export function groupViewWrapper(lhs, rhs, deviceLayout) {

    if (deviceLayout == 'mobile') {
        return (
            <Grid container spacing={1}>
                <Grid item xxs={12} x3l={6}>
                    {lhs}
                </Grid>
                <Grid item xxs={12} x3l={6}>
                    <Box pb={1}>
                        {rhs}
                    </Box>
                </Grid>
            </Grid>
        );
    }
    else {
        return (
            <Box display="flex" flex={1} flexDirection={{ xxs: "column", lg: "row" }} height="auto">
                <Box flex={{ xxs: 12, lg: 8 }} pb={{ xxs: 1, lg: 0 }} pr={{ xxs: 0, lg: 0.5 }}>
                    {lhs}
                </Box>
                <Box flex={{ xxs: 12, lg: 4 }} pl={{ xxs: 0, lg: 0.5 }}>
                    {rhs}
                </Box>
            </Box>
        );
    }
}

export function loadingScreen(deviceLayout, bordered = false) {

    if (bordered) {
        return wrapper((
            <SoftBox
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                minHeight="100%"
            >
                <CircularProgress color="dark" />
                <SoftTypography variant="button" fontWeight="medium" mt={2} color="dark">
                    Loading...
                </SoftTypography>
            </SoftBox>
        ), deviceLayout, true
        );
    }
    else {
        return (
            <SoftBox
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                minHeight="100%"
            >
                <CircularProgress color="dark" />
                <SoftTypography variant="button" fontWeight="medium" mt={2} color="dark">
                    Loading...
                </SoftTypography>
            </SoftBox>
        );
    }
}